import { axios } from '@/plugins/axios-pol'

const BASE_PATH = '/personal/api/EstadoFuerza'

async function fetchPersonalByDependencia(idDependencia) {
  const response = await axios.get(`${BASE_PATH}/dependencias/${idDependencia}/personal`)

  return JSON.parse(response.data.data)
}

export default function createPersonalApiRepository() {
  return {
    fetchPersonalByDependencia,
  }
}
